import { StudentProgramsWithCourses } from '../../../../../api/types/students/programs/student-programs-with-courses';

// Helper function to calculate program-level attendance percentage
export const calculateProgramAttendancePercentage = (
  program: StudentProgramsWithCourses,
): number => {
  let totalAttendedLectures = 0;
  let totalLecturesWithAttendance = 0;

  // Loop through all courses in the program
  program.courses.forEach((course) => {
    // Find lectures with recorded attendance (attendanceId !== null)
    const lecturesWithAttendance =
      course.lectures?.filter((lecture) => lecture.attendanceId !== null) ?? [];

    // Find attended lectures (attended or late)
    const attendedLectures = lecturesWithAttendance.filter(
      (lecture) =>
        lecture.attendanceType === 'attended' ||
        lecture.attendanceType === 'late',
    );

    totalLecturesWithAttendance += lecturesWithAttendance.length;
    totalAttendedLectures += attendedLectures.length;
  });

  // If no attendance was recorded for any lecture in the program, consider it 100% attendance
  const programAttendancePercentage =
    totalLecturesWithAttendance > 0
      ? Math.round((totalAttendedLectures / totalLecturesWithAttendance) * 100)
      : 100;

  return programAttendancePercentage;
};
